<template>
  <div class="app-header">
    <div class="container-section d-flex app-header__bar">
      <div class="header__logo">
        <a href="#/">
          <svg class="_icon-logo" :style="isDark ? 'color:#3a84f3' : 'color:#11519c'">
            <use href="/img/webapp/logoSVG.svg#logo"></use>
          </svg>
        </a>
      </div>

      <v-spacer></v-spacer>

      <div class="d-flex align-center">
        <div class="text-xs-center" v-if="userFIO && isLogin">
          <v-btn
            v-if="!$vuetify.breakpoint.xs"
            class="white--text"
            color="#1370B9"
            style="text-transform: capitalize; font-weight: 500; font-size: 1.2rem; border-radius: 8px; letter-spacing: -.24px; line-height: 2.4rem;"
            href="/WebApp/#/"
          >
            {{ userFIO }}
          </v-btn>
        </div>

        <v-btn
          v-if="isLogin"
          @click="logout()"
          class="textStyle ml-1 mt-0 py-3"
          text
          :color="isDark ? '#3a84f3 !important' : '#004992'"
        >
          <svgIcon class="mr-2" iconName="log-out" :fill="isDark ? '#3a84f3' : '#004992'" :width="20" :height="20"></svgIcon>
          Выход
        </v-btn>

        <v-btn
          v-else
          text
          class="textStyle ml-1 mt-0 py-3"
          href="/WebApp/"
          :style="isDark ? 'color:#3a84f3 !important' : 'color:#004992'"
        >
          <svgIcon class="mr-2" iconName="log-in" :fill="isDark ? '#3a84f3' : '#004992'" :width="20" :height="20"></svgIcon>
          Вход
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import svgIcon from '@/components/ui/svgIcon'

export default {
  name: 'AppHeader',
  components: {
    svgIcon
  },
  computed: {
    userFIO () {
      return this.$store.getters.userFIO
    },
    isDark () {
      return this.$vuetify.theme.dark
    },
    isLogin () {
      return this.$store.getters.isLogin
    }
  },
  methods: {
    logout () {
      window.getApp.$emit('APP_LOGOUT')
    }
  }
}
</script>

<style scoped>
.app-header {
  background: transparent;
}

.app-header__bar {
  padding-top: 1rem;
  padding-bottom: 1rem;
  min-height: 30px;
  align-items: center;
}

.header__logo svg {
  height: 3.6rem;
  width: 17rem;
}

.textStyle {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0.01em;
  color: #004992 !important;
}

.container-section {
  display: block;
  margin: 0 auto;
  max-width: 75rem;
  width: calc(100% - 4rem);
}

@media (max-width: 767px) {
  .header__logo svg {
    height: 2.3rem;
    width: 10.2rem;
  }

  .container-section {
    max-width: calc(100% - 2.4rem);
    width: calc(100% - 2.4rem);
  }
}
</style>
